<template>
  <div class="workflow-steps">
    <div class="row">
      <div class="col-10">
        <h1 class="pagetitle">Workflow steps template settings:</h1>
        <div>
          <button class="btn btn-big btn-blue" v-on:click="addStep">
            Add new step
          </button>
        </div>
      </div>
    </div>

    <preloader v-bind:value="WorkFlowSteps.length === 0" />

    <div class="steps-list">
      <div
        class="workflow-step-item"
        v-for="WorkFlowStep in WorkFlowSteps"
        :key="WorkFlowStep.ID"
      >
        <h2>{{ WorkFlowStep.Name }}</h2>

        <div class="workflow-step-steps_holder">
          <div
            class="workflow-step-wrapper"
            v-for="(Step, index) in WorkFlowStep.Steps"
            :key="Step.ID"
          >
            <div class="workflow-step-inner">
              <h3 class="workflow-step-header">{{ Step.Name }}</h3>

              <div class="workflow-step__button-wrapper">
                <button
                  class="workflow-step-button workflow-step-button--edit"
                  v-on:click="editStep(Step)"
                >
                  Edit
                </button>

                <button
                  class="workflow-step-button"
                  @click="confirmRemove(Step)"
                >
                  Remove
                </button>
              </div>
            </div>
            <div
              class="workflow-step-arrow arrow-fx-center"
              v-if="index != WorkFlowStep.Steps.length - 1"
            >
              ›
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="modal-wrapper" v-if="newStepItem">
        <div @click="CloseModalDialog" class="modal-backdrop"></div>
        <div class="modal-inner">
          <button
            class="close-modal edit-step-close"
            v-on:click="CloseModalDialog"
          >
            <i class="fas fa-window-close"></i>
          </button>

          <form v-on:submit.prevent="submitSteps">
            <h3>Add new step</h3>

            <div class="space-down edit-step-form">
              <div class="edit-step-form--item">
                <p>Step Name</p>
                <input placeholder="step name"  type="text" v-model="newStepItem.Name" required />
              </div>

              <div class="edit-step-form--item">
                <p>Category</p>

                <select v-model="newStepItem.TypeID" required>
                  <option value="1">Project</option>
                  <option value="2">Task</option>
                  <option value="3">Job</option>
                  <option value="4">Report</option>
                </select>
              </div>
              <div class="edit-step-form--item">
                <p>Position</p>
                <input  @keydown="numberKeyDown" min="0" type="number" v-model="newStepItem.Position" required />
              </div>
            </div>
            <input type="submit" value="Submit" class="btn btn-blue" />
          </form>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal-wrapper" v-if="confirm">
        <div @click="confirm = null" class="modal-backdrop"></div>
        <div class="modal-inner">
          <button class="close-modal edit-step-close" @click="confirm = null">
            <i class="fas fa-window-close"></i>
          </button>

          <div class="modal-steps-confirm">
            <h4>Remove this step?</h4>
            <div class="modal-steps-confirm__choice">
              <button @click="removeStep" class="btn btn-danger">yes</button>
              <button @click="confirm = null" class="btn btn-neutral">
                no
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import preloader from '@/components/preloader';

export default Vue.extend({
  name: 'WorkFlowSteps',
  data() {
    return {
      newStepItem: null,
      WorkFlowSteps: [],
      confirm: null,
    };
  },
  components: {
    preloader,
  },
  methods: {
    numberKeyDown(e) {
      e.preventDefault();
      this.newStepItem.Position = 0;
    },
    sortWorkflowSteps(WorkflowSteps) {
      const sortedSteps = WorkflowSteps.map((item) => {
        const sortedPosition = item.Steps.sort((a, b) => {
          return a.Position > b.Position ? 1 : -1;
        });
        return { ...item, sortedPosition };
      });
      return sortedSteps;
    },
    getAllSteps() {
      Api.settings.workflowsConfiguration
        .getAllSteps()
        .then((res) => {
          res.status == 200
            ? (this.WorkFlowSteps = this.sortWorkflowSteps(res.data))
            : (this.WorkFlowSteps = []);
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: 'Sorry, something went wrong!',
            type: 'error',
            show: true,
          });
        });
    },

    addStep() {
      this.newStepItem = {
        Name: '',
        PhaseID: null,
        TypeID: 1,
        Position: 1,
      };
    },
    submitSteps() {
      if (this.newStepItem.hasOwnProperty('ID')) {
        Api.settings.workflowsConfiguration
          .editStep(this.newStepItem)
          .then((res) => {
            if (res.status == 200 || res.status == 204) {
              this.newStepItem = null;
              this.getAllSteps();
            }
          });
      } else {
        Api.settings.workflowsConfiguration
          .addStep(this.newStepItem)
          .then((res) => {
            if (res.status == 200 || res.status == 204) {
              this.newStepItem = null;
              this.getAllSteps();
            }
          });
      }
    },
    CloseModalDialog() {
      this.newStepItem = null;
    },
    editStep(step) {
      const bufferStep = { ...step };
      this.newStepItem = bufferStep;
    },
    removeStep() {
      if (this.confirm) {
        Api.settings.workflowsConfiguration
          .removeStep(this.confirm)
          .then((res) => {
            if (res.status == 200 || res.status == 204) {
              this.$root.$emit('notification', {
                message: 'Step is removed.',
                type: 'info',
                show: true,
              });
              this.confirm = null;
              this.WorkFlowSteps = [];
              this.getAllSteps();
            }
          });
      }
    },
    confirmRemove(step) {
      const bufferStep = { ...step };
      this.confirm = bufferStep.ID;
    },
  },
  created() {
    this.getAllSteps();
  },
});
</script>

<style src="./steps.style.css"></style>
